import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { StaticInfoContainerComponent } from '../static-info-container/static-info-container.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-mp-profile-static-info-container',
  templateUrl: './mp-profile-static-info-container.component.html',
  styleUrls: [
    './mp-profile-static-info-container.component.scss',
    '../static-info-container/static-info-container.component.scss',
    '../../../profile/components/profile.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpProfileStaticInfoContainerComponent extends StaticInfoContainerComponent implements OnChanges {
  @Input() pendingSubmissionId: number = 0;
  @Output() viewSubmissionClicked = new EventEmitter<number>();

  private _pendingSubmissionId = new BehaviorSubject<number>(0);
  public pendingSubmissionId$ = this._pendingSubmissionId as Observable<number>;

  public showExistingSubmissionBanner$ = this.pendingSubmissionId$.pipe(map(id => !!id));

  public ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes.pendingSubmissionId) {
      this._pendingSubmissionId.next(this.pendingSubmissionId);
    }
  }

  public handleViewSubmissionClicked(): void {
    this.pendingSubmissionId$.once(id => this.viewSubmissionClicked.emit(id));
  }

  public handleEditButtonClick(): void {
    this.showExistingSubmissionBanner$.once(showBanner => {
      if (!showBanner && !this.disableActionButton) this.actionButtonClicked.emit();
    });
  }
}
